// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A12U9):
// the loader warms the member and their overrides through the same queryOptions the screen reads.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { MemberAccess } from '../../../../../features/members/MemberAccess'
import { memberAccessQuery, memberQuery } from '../../../../../features/members/queries'
import { Part } from '../../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/people/$membershipId/access')({
  staticData: { screenId: 'MemberAccessScreen', access: 'access.override or feature.assign' },
  loader: async ({ context: { queryClient, membership }, params }) => {
    await Promise.all([
      queryClient.ensureQueryData(memberQuery(membership.orgId, params.membershipId)),
      queryClient.ensureQueryData(memberAccessQuery(membership.orgId, params.membershipId)),
    ])
    return { orgId: membership.orgId }
  },
  component: MemberAccessScreen,
})

function MemberAccessScreen() {
  const { orgId } = Route.useLoaderData()
  const { orgSlug, membershipId } = Route.useParams()
  return (
    <main data-testid={ids.memberAccess.root}>
      <Part testId={ids.memberAccess.skeleton}>
        <MemberAccess orgId={orgId} orgSlug={orgSlug} membershipId={membershipId} />
      </Part>
    </main>
  )
}
